<template>
  <div class="fee-do">
    <div class="header">
      <el-input class="query" v-model.trim="invoiceNo" placeholder="请输入开票编号" clearable @keyup.native.enter="getApplyList(1)" @clear="getApplyList(1)"></el-input>
      <el-button type="primary" @click="getApplyList(1)">查询</el-button>
      <el-button class="swtich-btn" type="primary" @click="$emit('switchTab', 'undo')">继续开票</el-button>
    </div>
    <Table :data="billList" :columns="columns" :pages="pages"></Table>
    <!-- 开票详情 -->
    <el-dialog title="开票详情" :visible.sync="invoiceDetailVisible" width="1100px">
      <fee-do-detail ref="detailRef"></fee-do-detail>
    </el-dialog>
  </div>
</template>
<script>
import InvoiceService from "@/apis/InvoiceService";
import orderService from "@/apis/orderService";
import Table from "@/components/new-table.vue";
import FeeDoDetail from "./fee-do-detail.vue";
import { InvoiceState, InvoiceStateLabel } from "@/service/enum"
import { MessageBox } from "element-ui";
export default {
  components: { Table, FeeDoDetail },
  data() {
    return {
      invoiceNo: "",
      billList: [],
      columns: [
        { label: "开票编号", prop: "makeInvoiceNum", "min-width": "100px" },
        {
          label: "开票金额", prop: "makeInvoiceAmount", "min-width": "70px", render: (h, { row }) => {
            return <div> {orderService.toYuan((row.makeInvoiceAmount * 100).toFixed(0))} </div>
          }
        },
        { label: "申请人", prop: "applyUserName", "min-width": "110px" },
        { label: "申请时间", prop: "applyTime", "min-width": "110px" },
        { label: "开票状态", prop: "invoiceLabel", "min-width": "110px" },
        { label: "开票时间", prop: "makeInvoiceDate", "min-width": "110px" },
        {
          label: "操作", width: "140px", render: (h, { row }) => {
            const canCancel = [InvoiceState.pending, InvoiceState.doing].includes(row.invoiceState);
            return <div>
              <el-button type="text" onClick={() => { this.showDetail(row) }}>详情</el-button >
              {canCancel && <el-button type="text" onClick={() => { this.cancelInvoice(row) }}>撤销申请</el-button >}
            </div >
          }
        },
      ],
      pages: {
        props: {
          total: 0,
          "page-size": 20,
          "current-page": 1,
        },
        on: {
          "current-change": this.currentChange,
          "size-change": this.sizesChange
        },
      },
      invoiceDetailVisible: false,
    }
  },
  mounted() {
    this.getApplyList();
  },
  methods: {
    getApplyList(pageIndex) {
      const page = pageIndex || this.pages.props["current-page"];
      const pageSize = this.pages.props["page-size"];
      InvoiceService.getFeeApplyList(page, pageSize, this.invoiceNo).then(res => {
        this.billList = res.data.map(i => {
          i.invoiceLabel = InvoiceStateLabel[i.invoiceState]
          return i;
        });
        this.pages.props.total = res.dataCount;
      });
    },
    cancelInvoice(row) {
      MessageBox.confirm("确定要撤销该发票的申请吗？", "注意", {
        showCancelButton: true,
        type: "warning"
      }).then(() => {
        InvoiceService.cancelInvoiceApply(row.id).then(res => {
          if (!res) return;
          row.invoiceState = InvoiceState.cancel;
          row.invoiceLabel = InvoiceStateLabel[row.invoiceState];
        })
      });
    },
    sizesChange(val) {
      this.pages.props["page-size"] = val;
      this.getApplyList(1);
    },
    currentChange(page) {
      this.pages.props["current-page"] = page;
      this.getApplyList();
    },
    showDetail(row) {
      this.invoiceDetailVisible = true;
      this.$nextTick(() => {
        this.$refs.detailRef.getList(row.id);
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.fee-do {
  display: flex;
  flex-direction: column;
  width: 100%;
  .header {
    margin-bottom: 20px;
    position: relative;
  }
  .swtich-btn {
    position: absolute;
    right: 10px;
    top: 0;
  }
  .query {
    width: 200px;
    margin-right: 20px;
    vertical-align: middle;
  }
}
</style>